import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import store from '../store/index'

// axios.defaults.withCredentials = true

function refresh_token(failedRequest) {
  return new Promise((resolve, reject) => {
    axios
      .post(store.getters.refresh_token_url)
      .then((tokenRefreshResponse) => {
        var token = tokenRefreshResponse.data.token

        localStorage.setItem('token', token)
        setAuthHeaders()

        failedRequest.response.config.headers['Authorization'] =
          'Bearer ' + token
        failedRequest.response.config.headers['Accept'] = 'application/json'

        resolve()
      })
      .catch((err) => {
        store
          .dispatch('login')
          .then(() => resolve())
          .catch((error) => {
            console.log(error)
            //window.location.reload()
          })
      })
  })
}

// Function that will be called to refresh authorization
const refreshAuthLogic = (failedRequest) => refresh_token(failedRequest)

// Instantiate the interceptor (you can chain it as it returns the axios instance)
var new_axios = createAuthRefreshInterceptor(axios, refreshAuthLogic)

function setAuthHeaders() {
  var token = localStorage.getItem('token')

  if (token) {
    axios.defaults.headers['Authorization'] = 'Bearer ' + token
    axios.defaults.headers['Accept'] = 'application/json'
  }
}

setAuthHeaders()

axios.interceptors.request.use(
  (config) => {
    var webuser_id = localStorage.getItem('webuser_id')
    var webuser_token = localStorage.getItem('webuser_token')
    if (webuser_token && webuser_id) {
      axios.defaults.headers['WebuserId'] = webuser_id
      axios.defaults.headers['WebuserToken'] = webuser_token
      axios.defaults.headers['DomainName'] = location.hostname
    }
    return config
  },
  (error) => {
    // handle the error
    return Promise.reject(error)
  }
)

window.axios = new_axios

export default new_axios
